import cryptoRandomString from 'crypto-random-string';

/**
 * Generates a random password based on the provided options.
 * @param {Object} options - The options for generating the password.
 * @param {number} [options.length=20] - The length of the password.
 * @param {boolean} [options.includeLowercase=true] - Whether to include lowercase letters in the password.
 * @param {boolean} [options.includeUppercase=true] - Whether to include uppercase letters in the password.
 * @param {boolean} [options.includeNumbers=true] - Whether to include numbers in the password.
 * @param {boolean} [options.includeSpecialSymbols=true] - Whether to include special symbols in the password.
 * @returns {string} The generated password.
 */
const passwordGenerator = (options) => {
  const {
    length = 20,
    includeLowercase = true,
    includeUppercase = true,
    includeNumbers = true,
    includeSpecialSymbols = true,
  } = options || {};

  const characterSets = {
    lowercase: 'abcdefghijklmnopqrstuvwxyz',
    uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    numbers: '0123456789',
    specialChars: '!@#$%^&*()_-+=',
  };

  let characterSet = '';
  let remainingLength = length;
  const bufferArray = [];

  if (includeLowercase) {
    characterSet += characterSets.lowercase;
    remainingLength -= 1;
    bufferArray.push(cryptoRandomString({ length: 1, characters: characterSets.lowercase }));
  }
  if (includeUppercase) {
    characterSet += characterSets.uppercase;
    remainingLength -= 1;
    bufferArray.push(cryptoRandomString({ length: 1, characters: characterSets.uppercase }));
  }
  if (includeNumbers) {
    characterSet += characterSets.numbers;
    remainingLength -= 1;
    bufferArray.push(cryptoRandomString({ length: 1, characters: characterSets.numbers }));
  }
  if (includeSpecialSymbols) {
    characterSet += characterSets.specialChars;
    remainingLength -= 1;
    bufferArray.push(cryptoRandomString({ length: 1, characters: characterSets.specialChars }));
  }

  bufferArray.push(
    cryptoRandomString({
      length: remainingLength,
      characters: characterSet,
    }),
  );

  for (let i = bufferArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [bufferArray[i], bufferArray[j]] = [bufferArray[j], bufferArray[i]];
  }

  return bufferArray.join('');
};

export default passwordGenerator;
